import { BuildInAppToolId } from '../types/appTools';

export const AppToolbarAwarenessDotConfig = {
    [BuildInAppToolId.Messages]: {
        featureToggleName: 'messages-notification-awareness-test',
    },
};
